// frontend/src/components/ProtectedRoute.jsx
import { useEffect } from "react";
import { useAuth } from "../context/authcontext";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!loading && !user) {
      navigate("/login", { replace: true });
    }
  }, [loading, user, navigate]);
  
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-main-gradient">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return null;
  return children;
};

export default ProtectedRoute;